import React, {useState, useContext, useEffect} from "react";
import AmChartWaterfall from "../../../components/AmChartWaterfall";
import SelectionTool from '../../../components/SelectionTool';


export default function RealEstateWaterfall({onClick}){
	
	const [waterfallData, setWaterfallData] = useState([]);
	const [loaded, setLoaded] = useState("false");
	
	useEffect(() => {
		loadWaterfallData();
		setLoaded("true");
	}, [loaded]);
	
	const optionValues = [
		{id:"1", name:"Area"},
		{id:"2", name:"Cost"},
		{id:"3", name:"Capacity"}
	];
	
	const optionValuesYears = [
		{id:"1", name:"1Y"},
		{id:"2", name:"5Y"},
		{id:"3", name:"10Y"}
	];
	
	const loadWaterfallData = () => {
		let tempWaterfallData = [{
		  "category": "Current",
		  "open1": 0,
		  "close1": 83,
		  "open2": 83,
		  "close2": 128
		}, {
		  "category": "Disposals",
		  "open1": 121,
		  "close1": 128,
		  "open2": 128,
		  "close2": 128
		}, {
		  "category": "Acquisitions",
		  "open1": 111,
		  "close1": 114,
		  "open2": 114,
		  "close2": 121
		}, {
		  "category": "Lease Terminations",
		  "open1": 98,
		  "close1": 108,
		  "open2": 108,
		  "close2": 111
		}, {
		  "category": "Break Options Exercised",
		  "open1": 85,
		  "close1": 96,
		  "open2": 96,
		  "close2": 98
		}, {
		  "category": "Remaining Portfolio",
		  "open1": 0,
		  "close1": 70,
		  "open2": 70,
		  "close2": 85
		}];
		
		setWaterfallData(tempWaterfallData);
		
	};

	const openCloseKeys = [
		{open:"open1", close:"close1" , label:"Owned", showTotal:false, color:"#ff6600"},
		{open:"open2", close:"close2" , label:"Leased", showTotal:true, color:"#0000ff"}
	];
	
		
	const thisContainer = {
		display:"flex",
		width:"calc(100% - 40px)",
		flexDirection:"column",
		alignItems:"center",
		justifyContent:"space-around",
		paddingLeft:"10px",
		backgroundColor:"white",
		borderRadius:"6px",
		marginLeft:"20px",
		marginTop:"20px",
		height:"500px"
	};
	
	
	return (
		<div style={thisContainer}>
			
			<AmChartWaterfall
				chartId="realestatehomewaterfall"
				width="100%"
				height="440px" 
				chartData={waterfallData} 
				categoryKey="category" 
				openCloseKeys={openCloseKeys}
				onClick={onClick}
			>
			</AmChartWaterfall>
			<SelectionTool
				title="Show"
				value="Area"
				values={optionValues}
				dataLoad={loadWaterfallData}
			>
			</SelectionTool>
			<SelectionTool
				title="Tomescale"
				value="5Y"
				values={optionValuesYears}
				dataLoad={loadWaterfallData}
			>
			</SelectionTool>
		</div>
	);
}